<template>
  <div id="app">
    <el-container id="container-box" v-if="$store.state.isLogin">
      <el-header>
        <Navbar @aiOpen="Aiopen" />
      </el-header>
      <el-main>
        <router-view />
      </el-main>
      <footer class="fix-to-bottom">
        <div class="mundb-footer">
          <span class="footer-text">Copyright@2015-2026</span>
          <span class="footer-text">备案号：京ICP备17070826号-5</span>
        </div>
      </footer>
      <transition name="el-zoom-in-bottom">
        <div id="person-icon" class="hvr-pulse" v-show="!flag" ref="personicon" @click="Aiopen">
          <img class="ai-zj" src="https://file.magaoedu.com/fad5de0ee8c6ecffbe1dad0bb26d0a4b.png" />
          <span>码小高</span>
        </div>
      </transition>
      <transition name="el-zoom-in-bottom" style="z-index: 1000">
        <!-- drag -->
        <div :id="fullScreen ? 'popup-box-content-fullScreen' : 'popup-box-content'" v-show="flag">
          <div :id="fullScreen ? 'popup-box-data-fullScreen' : 'popup-box-data'" ref="popupdata">
            <div class="app-close">
              <div></div>
              <div :class="fullScreen ? 'popup-box-title-fullScreen' : 'popup-box-title'">
                <span style="margin-top: 4px">码小高</span>
                <span style="display: block; font-size: 12px; font-weight: normal; color: #717070"> 本功能由 DeepSeek-R1 驱动 </span>
              </div>
              <div>
                <el-button type="text" style="margin-right: 10px; font-size: 16px; font-weight: bold" @click="changeFullScreen">{{ fullScreen ? "退出全屏" : "全屏" }}</el-button>
                <el-button style="margin-right: 10px; font-size: 16px; font-weight: bold" @click="flag = false">关闭</el-button>
              </div>
            </div>
            <div :class="fullScreen ? 'app-main-fullScreen' : 'app-main'">
              <!-- <iframe src="http://192.168.1.116:8080/?isWendao=1#/chat" width="100%" height="100%" frameborder="0" ref="iframe"></iframe> -->
              <iframe src="https://schoolai.magaoedu.com/?isWendao=1#/chat" width="100%" height="100%" frameborder="0" ref="iframe"></iframe>
            </div>
          </div>
        </div>
      </transition>
    </el-container>
    <transition name="el-fade-in-linear">
      <Login v-if="!$store.state.isLogin"></Login>
    </transition>
  </div>
</template>
<script>
import Login from "./views/Login.vue";
import Navbar from "./components/Navbar.vue";
window.sources = null;
import axios from "axios";
const CancelToken = axios.CancelToken;
window.sources = CancelToken.source();
export default {
  name: "app",
  components: {
    Login,
    Navbar,
  },
  watch: {
    "$store.state.isLogin"(newVal, oldVal) {
      //对数据执行操作
      this.flag = false;
      this.rechargeShow = false;
      this.dialogVisible = false;
      this.checkAmount = 1490;
    },
  },
  data() {
    return {
      fullScreen: false,
      rechargeTimer: null,
      times: 0,
      isLogin: false,
      flag: false,
      redirect: "",
      remaining: 0,
      unitPrice: 0,
      aiFlag: 1,
      validityDay: "",
      rechargeShow: false,
      checkAmount: 1490,
      dialogVisible: false,
      payImg: "",
      successFlag: false,
      logInfo: {},
      imageList: ["https://file.magaoedu.com/43869e0bc52030d57c76794ca74cd288.jpg", "https://file.magaoedu.com/aa24646b36885cc1e1b7b276725a1d94.jpg", "https://file.magaoedu.com/97693da9e52c689323d2d09f63ea3fbf.jpg"],
    };
  },
  methods: {
    Aiopen() {
      this.logInfo = JSON.parse(localStorage.getItem("loginInfo"));
      this.flag = true;
      this.$modal.show("example");
      this.getRemain();
    },

    changeFullScreen() {
      this.fullScreen = !this.fullScreen;
    },

    initTimer() {
      if (this.rechargeTimer != null) {
        clearInterval(this.rechargeTimer);
        this.rechargeTimer = null;
        this.times = 0;
      }
    },

    radioChange() {
      this.initTimer();
      this.openQrbox();
    },

    // 充值
    openQrbox() {
      let day = this.checkAmount == 149 ? 30 : this.checkAmount == 410 ? 90 : 365;
      let _this = this;
      this.dialogVisible = true;
      let postData = {
        token: this.$store.state.token,
        identity: this.logInfo.isShow,
        studentId: this.logInfo.id,
        amount: this.checkAmount,
        day,
      };
      this.$axios.post(this.$API.aiUnifiedOrder, this.$todo.formData(postData)).then((res) => {
        if (res.status && res.status == 500) {
          _this.$message.warning("请重新选择充值金额");
        } else {
          _this.payImg = res;
          _this.payIsComplete(res);
        }
      });
    },

    // 取消充值
    beforeClose(done) {
      this.$confirm("是否放弃本次支付, 是否继续?", "支付未完成", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          done();
          this.rechargeShow = false;
        })
        .catch(() => {});
    },

    closeRecharge() {
      this.checkAmount = 1490;
      this.initTimer();
    },

    // 轮询一下
    payIsComplete(data) {
      let _this = this;
      this.initTimer();
      this.rechargeTimer = setInterval(() => {
        data = _this.payImg;
        if (data) {
          let length = data.split("/");
          let id = data.split("/")[length.length - 1];
          _this.$axios
            .post(
              _this.$API.tradeQuery,
              _this.$todo.formData(
                {
                  outTradeNo: id,
                },
                {
                  cancelToken: window.sources.token,
                }
              )
            )
            .then((res) => {
              if (res.status == 200) {
                _this.initTimer();
                _this.dialogVisible = false;
                _this.rechargeShow = false;
                _this.checkAmount = 1490;
                _this.successFlag = true;
                _this.getRemain();
              } else {
                if (_this.times > 3000) {
                  _this.initTimer();
                  _this
                    .$confirm("支付未完成，是否继续支付?", "支付未完成", {
                      confirmButtonText: "确定",
                      cancelButtonText: "取消",
                      type: "warning",
                    })
                    .then(() => {
                      _this.openQrbox();
                    })
                    .catch(() => {
                      _this.dialogVisible = false;
                      _this.rechargeShow = false;
                      _this.checkAmount = 1490;
                    });
                } else {
                  _this.times++;
                }
              }
            });
        }
      }, 2000);
    },
    // 获取余额
    getRemain() {
      let postData = {
        studentId: this.logInfo.id,
        identity: this.logInfo.isShow,
      };
      this.$axios
        .post(this.$API.balance, this.$todo.formData(postData))
        .then((res) => {
          this.remaining = res.data.balance;
          this.aiFlag = res.data.flag;
          this.unitPrice = Number(res.data.aiUnitPrice);
          this.validityDay = res.data.endTime.split("T")[0];
          this.sendMessage();
        })
        .catch((error) => {});
    },

    // 计算余额
    caculateRemaining(mount) {
      let currentCost = mount * this.unitPrice;
      let remain = this.remaining - currentCost;
      return remain;
    },

    // 同步余额到Ai助手
    sendMessage() {
      let _this = this;
      const mapFrame = this.$refs["iframe"];
      console.dir(mapFrame)
      if (mapFrame && mapFrame.contentWindow) {
        const iframeWin = mapFrame.contentWindow;
      console.dir(iframeWin)
        
        iframeWin.postMessage(
          {
            type: 1,
            remain: _this.remaining,
            validityDay: _this.validityDay,
            flag: _this.aiFlag,
          },
          "*"
        );
      }
    },

    // 保存记录
    saveRecord(type, details) {
      const charNumber = details.length;
      const usageAmount = details.length * this.unitPrice;
      this.remaining = this.caculateRemaining(details.length).toFixed(6);
      if (this.remaining <= 0) {
        this.aiFlag = 2;
      }
      this.sendMessage();
      let postData = {
        studentId: this.logInfo.id,
        identity: this.logInfo.isShow,
        type, // 0提问1回复',
        details,
        charNumber, //字符数
        usageAmount: usageAmount.toFixed(6), // 使用金额
        remainingAmount: this.remaining, // 剩余金额
      };
      this.$axios
        .post(this.$API.saveUsage, this.$todo.formData(postData))
        .then((res) => {})
        .catch((error) => {});
    },

    // 充值
    recharge() {
      this.rechargeShow = true;
      this.openQrbox();
    },
  },
  mounted() {
    let _this = this;
    window.addEventListener(
      "message",
      function (e) {
        if (e.data) {
          if (e.data.type == 0 || e.data.type == 1) {
            _this.saveRecord(e.data.type, e.data.msg);
          } else if (e.data.type == 2) {
            _this.recharge();
          }
        }
      },
      false
    );
    if (this.$todo.getCookie("token")) {
      this.$store.commit("updateToken", true);
      this.$store.commit("setToken", this.$todo.getCookie("token"));
    } else {
      this.$store.commit("updateToken", false);
    }
    this.$nextTick(() => {
      document.addEventListener("keydown", (e) => {
        if (e.keyCode == 27) {
          this.flag = false;
        }
      });
    });
  },
  beforeDestroy() {
    this.flag = false;
  },
};
</script>
<style>
::-webkit-scrollbar {
  width: 5px;
  height: 6px;
  background: none;
}

::-webkit-scrollbar-thumb {
  -webkit-box-shadow: inset 0 0 16px rgb(186, 172, 172);
}
</style>
<style scoped>
.footer-text {
  margin: 0 20px;
}
.ai-zj {
  width: 50px;
  height: 50px;
  margin-bottom: 5px;
}
.stepsToGuide {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

footer {
  color: #555 !important;
  background-color: #fff;
  text-align: center;
  background-color: #ffff;
}

footer a {
  color: #555;
}

footer a:hover {
  color: #409eff;
  text-decoration: none;
}
footer h1 {
  font-family: -apple-system, BlinkMacSystemFont, Segoe UI, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Helvetica Neue, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol;
  font-weight: 300;
  color: #3d3d3d;
  line-height: 1.1;
  font-size: 1.5rem;
}

.mundb-footer {
  padding: 38px 0;
  width: 100%;
  font-weight: 400;
  font-size: 1rem;
  line-height: 1;
}

#person-icon {
  width: 70px;
  padding: 10px;
  /* background-color: #fff; */
  border-radius: 50%;
  cursor: pointer;
  position: fixed;
  right: 20px;
  bottom: 100px;
  z-index: 999999;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  /* box-shadow: 50px 50px 100px 100px rgba(0, 0, 0, 0.1); */
}

#person-icon span {
  text-align: center;
  font-weight: bold;
  margin-left: 3px;
}

.ui.page.dimmer {
  background-color: rgba(0, 0, 0, 0) !important;
}

#popup-box-content {
  /* max-width: 1020px; */
  /* min-width: 1020px; */
  height: 620px;
  position: fixed;
  right: 20px;
  background-color: #fff;
  bottom: 80px;
  z-index: 1000;
  border-radius: 10px;
  box-shadow: 50px 50px 100px 100px rgba(0, 0, 0, 0.1);
}

#popup-box-content-fullScreen {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0px;
  left: 0px;
  bottom: 40px;
  background-color: #fff;
  z-index: 1000;
  border-radius: 10px;
  box-shadow: 50px 50px 100px 100px rgba(0, 0, 0, 0.1);
}

#popup-box-guide {
  max-width: 400px;
  min-width: 400px;
  height: 600px;
  position: absolute;
  left: 0px;
  background-color: #fff;
  z-index: 1000;
  border-radius: 10px;
}

.app-example {
  height: 60px;
  display: flex;
  align-items: center;
  background: rgb(226, 246, 237);
  justify-content: space-around;
}

.app-exaMain {
  width: 400px;
  height: calc(100% - 80px);
}

.app-exaMain /deep/ .el-carousel__container {
  height: 621px;
}

.app-exaMain /deep/ .el-carousel__button {
  background-color: #555;
}

.app-img {
  width: 400px;
  height: 620px;
}

#popup-box-data {
  max-width: 620px;
  min-width: 620px;
  height: 680px;
  position: absolute;
  right: 0px;
  background-color: #fff;
  z-index: 1000;
  border-radius: 10px;
  box-shadow: 50px 50px 100px 0px rgba(0, 0, 0, 0.1);
}

#popup-box-data-fullScreen {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
  background-color: #fff;
  z-index: 1000;
  border-radius: 10px;
  box-shadow: 50px 50px 100px 0px rgba(0, 0, 0, 0.1);
}

.popup-box-title {
  color: #000;
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  padding-left: 54px;
}
.popup-box-title-fullScreen {
  color: #000;
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  padding-left: 54px;
}

.app-close {
  height: 60px;
  display: flex;
  align-items: center;
  background: rgb(226, 246, 237);
  justify-content: space-between;
  box-shadow: -1px 0px 10px 0px rgba(159, 158, 158, 0.1);
}

.app-main {
  width: 620px;
  height: calc(100% - 60px);
}

.app-main-fullScreen {
  width: 100%;
  height: calc(100% - 60px);
}

@import "./styles/main.css";

.el-popper {
  /* left: 0!important; */
  /* right:200px!important; */
}

.ai-box {
  position: absolute;
  right: 20px;
  bottom: 100px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

#app {
  width: 100%;
  height: 100%;
}

.el-header {
  padding: 0 !important;
}

#container-box {
  min-height: 100%;
  background-color: #eff3f5 !important;
}

.el-main {
  color: #333;
  height: 100%;
  padding: 0 3% !important;
}

body > .el-container {
  margin-bottom: 40px;
}

.remain {
  font-size: 16px;
  font-weight: 700;
  text-align: center;
  color: #110b01;
  /* padding: 0px 30px; */
}

.amountArea {
  padding: 20px 40px 0px 40px;
  justify-content: space-around;
}

.wx-svg {
  display: inline-block;
  width: 160px;
  background: #f2f2f2;
  margin-top: 19px;
  padding: 6px 0 4px 4px;
  border-radius: 8px;
}

.radioLayout {
  display: flex !important;
  justify-content: space-between !important;
  border: none;
}

.radioLayout /deep/ .el-radio-button__inner:checked {
  color: #fff !important;
  background: linear-gradient(101.37deg, #fff9c6 1.05%, #ffe1c2 97.37%) !important;
  box-shadow: inset 0 0 0 2px #ffb66d !important;
}

.radioLayout /deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  color: #fff !important;
  background: linear-gradient(101.37deg, #fff9c6 1.05%, #ffe1c2 97.37%) !important;
  box-shadow: inset 0 0 0 2px #ffb66d !important;
}

.radioLayout /deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner .lackAmount {
  background: linear-gradient(270deg, #f60, #ffa047) !important;
  color: #fff;
}

.radioLayout /deep/ .el-radio-button__inner {
  border: 0px;
  border-radius: 8px !important;
  height: 120px;
  width: 130px;
  padding: 12px 4px;
  color: #02a7f0;
  background-color: #f7f9fc;
}

.radioLayout /deep/ .el-radio-button__inner:checked {
  color: #fff !important;
}

.radioLayout /deep/ .el-radio-button__orig-radio:checked {
  color: #fff !important;
}

.month {
  text-align: center;
  font-size: 16px;
  color: #495366;
  margin-left: 2px;
  margin-top: 4px;
}

.amount {
  display: inline-block;
  font-size: 36px;
  font-weight: bold;
  text-align: center;
  margin-left: -4px;
  color: #f60;
}

.realAmount {
  color: #030b1a;
  font-size: 12px;
  opacity: 0.3;
  margin-left: 8px;
  text-decoration: line-through;
}

.lackAmount {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 18px;
  background-color: #fff6e8;
  color: rgba(107, 45, 0, 0.6);
  border-radius: 0 0 7px 7px;
  width: 100%;
}

.recharge-area {
  margin-top: 20px;
  display: flex;
  height: 150px;
}

.actual-payment {
  font-size: 16px;
  font-weight: 700;
  margin: 20px 0 0 30px;
}

.actual-payment span {
  color: #02a7f0;
  font-size: 24px;
}

.radioLayout div {
  padding-top: 4px;
}

.pay-dialog-wx /deep/ .el-dialog {
  position: absolute;
  border-radius: 10px;
  right: 750px;
}

.pay-dialog /deep/ .el-dialog {
  position: absolute;
  border-radius: 10px;
  right: 900px;
}

.rechargeDialog /deep/ .el-dialog {
  position: absolute;
  border-radius: 10px;
  right: 650px;
}

.rechargeDialog /deep/ .el-radio-button:first-child .el-radio-button__inner {
  border-left: none;
}

.rechargeDialog /deep/ .el-radio-button {
  border-radius: 6px !important;
}

.rechargeDialog /deep/ .el-dialog__header {
  background: #1076f6;
  color: #fff !important;
  border-radius: 10px 10px 0 0;
}

.rechargeDialog /deep/ .el-dialog__title {
  color: #fff !important;
}

.rechargeDialog /deep/ .el-dialog__close {
  color: #fff !important;
}

.qrcode {
  width: 120px;
  height: 120px;
}

.qrcode img {
  width: 120%;
  height: 120%;
}

.pay-result {
  padding: 0px !important;
}
</style>
